export default class constants {
  static errorMessage = {
    firstName: 'Имя введено некорректно. Разрешено использование только кириллицы.',
    lastName: 'Фамилия введена некорректно. Разрешено использование только кириллицы.',
    email: 'E-mail введён некорректно. Проверьте формат адреса.',
    phone: 'Номер телефона введен некорректно. Допускаются только номера, начинающиеся с "+7".',
    newPassword: 'Пароль должен содержать не менее 6 символов.',
    newPasswordAgain: 'Пароль должен содержать не менее 6 символов.',
    newPasswordsNotEquals: 'Пароли не совпадают.',      
  }
  static imageSize = {
    miniAvatarSizes: {
      width: 50,
      height: 50
    },
    avatarSizes: {
      width: 185,
      height: 185
    },
    attachedImageSizes: {
      width: 105,
      height: 80
    } 
  }
};